<template>
    <tr v-if="option.values.length" class="specs">
        <td width="50%" class="rounded-l-lg" :class="{ 'bg-gray-50': gray }">
            <div class="attribute" v-if="option.attribute.description">
                <InfoModal :title="option.attribute.title" :body="option.attribute.description">
                    {{ option.attribute.title }}
                </InfoModal>
            </div>
            <div class="attribute" v-else>
                {{ option.attribute.title }}
            </div>
        </td>

        <td width="50%" class="rounded-r-lg" :class="{ 'bg-gray-50': gray }">
            <!-- N/A -->
            <i class="text-gray-600 italic" v-if="!option.values.length">Niet bekend</i>

            <!-- Yes -->
            <div v-else-if="option.attribute.type == 'level'" class="">
                <Levels :rating="parseFloat(option.values[0].value)" />
            </div>

            <!-- Yes -->
            <span
                v-else-if="option.attribute.type == 'boolean' && option.values[0].value == 1"
                class="flex items-center"
            >
                <fa :icon="['fal', 'check']" class="h-5 w-5 text-green-500" aria-hidden="true" />
                <span v-if="option.values[0].note" class="ml-2 text-xs text-gray-700"
                    >({{ option.values[0].note }})</span
                >
            </span>

            <!-- NO -->
            <span v-else-if="option.attribute.type == 'boolean'" class="flex items-center">
                <fa :icon="['fal', 'minus']" class="h-3 w-3 text-gray-400" aria-hidden="true" />
                <span v-if="option.values[0].note" class="ml-2 text-xs text-gray-700"
                    >({{ option.values[0].note }})</span
                >
            </span>

            <div v-else-if="option.values[0].compare_image">
                <vue-picture :image="option.values[0].compare_image" :name="option.values[0].value" :style="'h-6'" />
            </div>

            <div v-else-if="option.values[0].html">
                <div class="inline-block" v-for="value in option.values" :key="value.id" v-html="value.html"></div>
            </div>

            <!-- Array -->
            <span v-else-if="option.attribute.type == 'array'">
                <span v-for="(value, index) in option.values" :key="index">
                    <span v-if="index > 0">, {{ value.value }}</span>
                    <span v-else>{{ value.value }}</span>
                </span>
            </span>

            <!-- Download -->
            <span v-else-if="option.attribute.type == 'download'">
                <a target="_blank" :href="option.values[0].file.original_url" class="link" title="Download handleiding">
                    {{ option.values[0].file.file_name }}
                </a>
            </span>

            <!-- String -->
            <span v-else>{{ option.values[0].value ?? '-' }}</span>
        </td>
    </tr>
</template>

<script setup>
import Levels from '@/Blocks/Level.vue';
defineProps({
    option: Object,
    gray: Boolean,
});
</script>
        
